import React, { memo } from 'react';

const FieldsValidationsIcon = ({ color = '#335B70', ...props }) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
        <path
            d="M12.97 8.16 9.811 5.074l1.257-1.228 1.891 1.847L16.742 2 18 3.228 12.97 8.16ZM8.027 4.674H0v1.742h8.028V4.675Zm8.92 5.584L15.69 9.03l-2.31 2.257-2.31-2.257-1.258 1.229 2.31 2.256-2.31 2.257L11.069 16l2.31-2.256L15.69 16l1.259-1.228-2.31-2.257 2.31-2.256Zm-8.92 1.385H0v1.742h8.028v-1.742Z"
            fill={color}
        />
    </svg>
);

export default memo(FieldsValidationsIcon);
